import React, { useState, useCallback } from 'react';

import SubMenu from './SubMenu';
import TopLevelNav from './TopLevelNav';
import { NavItem } from './interfaces';
import { ComponentProps } from './props';
import * as Styled from './styled';

const NavBar: React.FC<ComponentProps> = ({ items, headerHeight, appElement }) => {
  const [openMenu, setOpenMenu] = useState<number[]>([]);
  /**
   * Event when any of the sub-menus are closed
   */
  const onSubMenuClose = () => setOpenMenu([]);

  const onTopMenuItemClick = useCallback(
    (selectedItem: NavItem) => {
      const { id } = selectedItem;
      if (openMenu.length === 0 || id !== items[openMenu[0]].id) {
        setOpenMenu([items.findIndex(el => el.id === id)]);
      } else {
        setOpenMenu([]);
      }
    },
    [items, openMenu]
  );

  return (
    <Styled.Wrapper>
      <TopLevelNav
        activeId={items[openMenu[0]]?.id ?? ''}
        items={items}
        onClick={onTopMenuItemClick}
      />
      <SubMenu
        openMenu={openMenu}
        setOpenMenu={setOpenMenu}
        items={items?.[openMenu[0]]?.subItems || []}
        onClose={onSubMenuClose}
        headerHeight={headerHeight}
        appElement={appElement}
      />
    </Styled.Wrapper>
  );
};

export default NavBar;
